import { ButtonStyled } from "theme/common/Button.styled"
import ContentDetailOrderActionsStyled from "theme/common/ContentDetailOrderActions.styled"
import { IconCheck } from "theme/common/Icon.styled"
import { IDeliveredReservaAction } from "interfaces/IShippingGroupAction"

const DeliveredReservaOrder = ({ loadingDeliveredReserva, onClickDeliveredReserva }: IDeliveredReservaAction) => {
  return (
    <ContentDetailOrderActionsStyled>
      <ButtonStyled
        variant="primary"
        loadingButton={loadingDeliveredReserva}
        disabled={loadingDeliveredReserva}
        onClick={onClickDeliveredReserva}
      >
        <IconCheck />
        <span>Confirmar Entrega</span>
      </ButtonStyled>
    </ContentDetailOrderActionsStyled>
  )
}

export default DeliveredReservaOrder
